module.exports = __webpack_public_path__ + "img/[月亮].c45b25aa.svg";